import { ref, Ref } from "vue"

export const useScrollPositionCheck = (
  outerContainer: Ref<HTMLElement>,
  innerContainer: Ref<HTMLElement>
) => {
  const scrolledCompletelyLeft = ref(true)
  const scrolledCompletelyRight = ref(false)

  // Check if the carousel is scrolled completely to the left or right
  const checkScrollPosition = () => {
    const _outerContainer = outerContainer.value
    const _innerContainer = innerContainer.value
    if (_outerContainer && _innerContainer) {
      scrolledCompletelyLeft.value = _innerContainer.scrollLeft <= 10
      scrolledCompletelyRight.value =
        _innerContainer.scrollLeft + _innerContainer.clientWidth >=
        _innerContainer.scrollWidth - 10
    }
  }

  const registerScrollPositionCheck = () => {
    checkScrollPosition()
    window.addEventListener("resize", checkScrollPosition)
    innerContainer.value.addEventListener("scroll", checkScrollPosition)
  }

  const unregisterScrollPositionCheck = () => {
    window.removeEventListener("resize", checkScrollPosition)
    innerContainer.value.removeEventListener("scroll", checkScrollPosition)
  }

  return {
    scrolledCompletelyLeft,
    scrolledCompletelyRight,
    registerScrollPositionCheck,
    unregisterScrollPositionCheck,
  }
}
